<!--
 * @Author: cn1994
 * @Date: 2023-08-23 10:11:23
 * @LastEditors: cn1994
 * @LastEditTime: 2023-10-13 15:40:35
 * @Description: 预览图顶部机构信息组件
-->
<template>
  <div class="ls-inst-info-component">
    <div class="avatar-wrap">
      <img :src="instInfo.instLogo">
    </div>

    <div class="title-wrap">
      <span class="title ellipsis-1">{{ instInfo.instTitle }}</span>
      <div class="subject-cell">
        <span class="subject">{{ instInfo.subject }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    instInfo: {
      type: Object,
    },
  },
}
</script>

<style lang="less" scoped>
.ls-inst-info-component {
  display: flex;
  flex-direction: row;
  background: rgba(255, 255, 255,.8);
  border-radius: 46px 46px 46px 46px;
  padding:6.5px 25.5px 5.5px 0;
  height: 55px;
  display: flex;
  align-items: center;
  .avatar-wrap {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    overflow: hidden;
    background: linear-gradient( 180deg, #E8F8FF 0%, #FEFFFF 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50% 50%;
    }
  }
  .title-wrap {
    display: flex;
    flex-direction: column;
    margin-left: 6px;
    .title {
      max-width: 100px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 15px;
      font-family: PingFang SC, PingFang SC;
    }
    .subject-cell {
      background-color: rgba(255, 255, 255, 0.50);
      height: 20px;
      border-radius: 17px;
      padding: 0 8px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 6px;
      width: fit-content;
      background-color: #1890FF;
      .subject {
        font-size: 12px;
        color: #333;
        line-height: 20px;
        color: #fff;
      }
      .icon {
        color: #1890ff;
        font-size: 20px;
      }
    }
  }
}
</style>
